import React, { FC } from "react";
import "./index.css";

const ZIcon = ({ unicode, className, style, ...props }) => {
  return (
    <i
      className={`z-icon select-none ${className}`}
      {...props}
      style={{
        fontFamily: "Wasabi",
        "--unicode": `"\\${unicode.toUpperCase()}"`,
        ...style,
      }}
    />
  );
};

export default ZIcon;
